$(document).ready(function() {
  $(".sold_product").each(function() {
    var soldProduct = $(this);
    var productId = soldProduct.attr("productid");
    var itemsArray = soldProduct.data("items").split(",");
    var hoursArray = soldProduct.data("hours").split(",");
    var lastUpdateTime = localStorage.getItem("lastUpdateTime_" + productId);
    lastUpdateTime = lastUpdateTime ? parseInt(lastUpdateTime) : 0;
    if (!lastUpdateTime) {
      var randomIndex = Math.floor(Math.random() * itemsArray.length);
      soldProduct.find(".items-count").text(itemsArray[randomIndex]);
      soldProduct.find(".hours-num").text(hoursArray[randomIndex]);
      localStorage.setItem("lastIndex_" + productId, randomIndex);
      localStorage.setItem("lastUpdateTime_" + productId, new Date().getTime());
    } else {
      var currentTime = new Date().getTime();
      var timeDifferenceHours = (currentTime - lastUpdateTime) / (1000 * 60 * 60);
      var lastIndex = localStorage.getItem("lastIndex_" + productId);
      lastIndex = lastIndex ? parseInt(lastIndex) : 0;
      var nextIndex = (lastIndex + 1) % Math.min(itemsArray.length, hoursArray.length);
      var nextUpdateHours = parseInt(hoursArray[nextIndex]);
      if (timeDifferenceHours >= nextUpdateHours) {
        soldProduct.find(".items-count").text(itemsArray[nextIndex]);
        soldProduct.find(".hours-num").text(nextUpdateHours);
        localStorage.setItem("lastIndex_" + productId, nextIndex);
        localStorage.setItem("lastUpdateTime_" + productId, currentTime);
      } else {
        soldProduct.find(".items-count").text(itemsArray[lastIndex]);
        soldProduct.find(".hours-num").text(hoursArray[lastIndex]);
      }
    }
  });
});